import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import { Button } from 'reactstrap';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { addDaysToCurrentDate } from 'site-modules/shared/utils/date-utils';
import { EventToolbox } from 'client/utils/event-toolbox';
/* Constants */
import { APPROVED_NON_MATCHED_VIN_COPY } from 'site-modules/shared/constants/financing/texts';
import { CAPITAL_ONE_LOGO_SRC } from 'site-modules/financing/constants/financing';
import { FINANCING_EVENTS } from 'site-modules/shared/constants/financing/financing-events';
import { GO_EXPIRATION_PRE_QUALIFICATION_DAYS } from 'client/site-modules/shared/constants/financing/financing';
/* Components */
import { Link } from 'site-modules/shared/components/link/link';

import './confirmation-container.scss';

export function ConfirmationContainer({
  link = '',
  copy = APPROVED_NON_MATCHED_VIN_COPY,
  cta = 'Start Shopping',
  isError = false,
}) {
  const expiresIn = dateFormat(addDaysToCurrentDate(GO_EXPIRATION_PRE_QUALIFICATION_DAYS), 'mm-dd-yyyy');

  const handleClick = () => {
    EventToolbox.fireCustomEvent(FINANCING_EVENTS.CONFIRMATION_CTA_CLICK, { isError, value: cta });
  };

  return (
    <div className="confirmation-wrapper mt-1_5">
      <div className="qualification-details p-1_5 text-center mx-auto">
        <div>
          <img
            className="d-block mx-auto"
            width={133}
            height={47}
            src={getStaticImageUrl(CAPITAL_ONE_LOGO_SRC)}
            alt="Capital One"
          />
        </div>
        <h1 className="size-30 fw-bold text-primary-darker my-1">You&apos;re pre-qualified!</h1>
        <div className="size-14 expired-date">Expires on {expiresIn}*</div>
      </div>
      <div className="p-1_5 mt-1_5 info-wrapper border-0 mx-auto">
        <div className="text-center copy">{copy}</div>
        <div className="d-flex justify-content-center w-100 my-2_5">
          <Button
            tag={Link}
            to={link}
            color="primary-b"
            size="lg"
            className="text-capitalize py-0_75 px-2 btn btn-blue-50 m-auto fw-normal size-20 confirmation-cta"
            onClick={handleClick}
            data-testid="confirmation-cta"
          >
            {cta}
            <i className="icon-arrow-right4 size-12 ms-0_25" aria-hidden />
          </Button>
        </div>
        <p className="size-12 validation-warning">
          *Your pre-qualification is valid 30 days from the date of the request (which may not be the same day of the
          decision in the case of reviewing/verifying status).
        </p>
      </div>
    </div>
  );
}
ConfirmationContainer.propTypes = {
  link: PropTypes.string,
  copy: PropTypes.string,
  cta: PropTypes.string,
  isError: PropTypes.bool,
};
